import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    active: Boolean,
    interval: { type: Number, default: 3000 },
  };

  connect() {
    if (!this.activeValue) return;

    this.frame = this.element.closest("turbo-frame");
    if (!this.frame) return;

    this.frame.addEventListener("turbo:fetch-request-error", this.schedule);
    this.frame.addEventListener("turbo:frame-missing", this.schedule);
    this.schedule();
  }

  disconnect() {
    clearTimeout(this.timer);
    this.frame?.removeEventListener("turbo:fetch-request-error", this.schedule);
    this.frame?.removeEventListener("turbo:frame-missing", this.schedule);
  }

  schedule = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.refresh(), this.intervalValue);
  };

  refresh() {
    if (document.hidden) {
      this.schedule();
      return;
    }

    if (this.frame.src) {
      this.frame.reload();
    } else {
      this.frame.src = this.urlValue;
    }
  }
}
